import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "./APIs/config";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function RequestDemo() {
  const [requestDemoList, setRequestDemoList] = useState([]);

  useEffect(() => {
    getRequestDemo();
  }, []);

  const getRequestDemo = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BASE_URL}/request_demo/get-request-demo`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data);
      setRequestDemoList(response.data);
    } catch (error) {
      console.error("Error fetching Request Demo:", error);
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-bg-primary">
      <Sidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <div className="p-6">
          <h1 className="text-3xl font-bold mb-6">
            Request Demo
          </h1>

        <div className="bg-white dark:bg-gray-900 rounded-xl shadow p-4 transition-colors duration-300">
  <div className="max-h-[500px] overflow-auto rounded-lg border border-gray-200 dark:border-gray-700">
    <table className="min-w-[1400px] w-full border-collapse">
      <thead className="bg-gray-100 dark:bg-gray-800 sticky top-0 z-10">
        <tr>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Admin Name</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Admin Email</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Phone</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Society Name</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Society Email</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Registration No.</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">RERA No.</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Address</th>
          <th className="px-4 py-3 border border-gray-200 dark:border-gray-700 text-left text-gray-900 dark:text-white">Pin Code</th>
        </tr>
      </thead>

      <tbody>
        {requestDemoList.map((item) => (
          <tr
            key={item.requestDemoId}
            className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.adminName}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.adminEmail}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.adminPhoneNumber}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 min-w-[220px] text-gray-900 dark:text-gray-100">{item.societyName}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.societyEmail}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.societyRegistrationNo}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.societyReraNo}</td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 min-w-[300px] break-words text-gray-900 dark:text-gray-100">
              {item.societyAddress}
            </td>

            <td className="border border-gray-200 dark:border-gray-700 px-4 py-3 text-gray-900 dark:text-gray-100">{item.pinCode}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
        </div>
      </div>
    </div>
  );
}